// extracted by mini-css-extract-plugin
module.exports = {"container":"X4S_dGtbZ-wOBaKoZ0UEF"};